import { IFillData } from "../../repository/IFillData";

export const fillCart = (payload: IFillData) => ({
  type: "@saga/FILL_CART",
  payload,
});
